import { render, staticRenderFns } from "./AuthorDetails.vue?vue&type=template&id=52da437a&scoped=true&"
import script from "./AuthorDetails.vue?vue&type=script&lang=js&"
export * from "./AuthorDetails.vue?vue&type=script&lang=js&"
import style0 from "./AuthorDetails.vue?vue&type=style&index=0&id=52da437a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52da437a",
  null
  
)

export default component.exports